import { __, registerBlockType, } from './common/variables';
import { cl } from './common/functions';
import { edit } from './components/edit';
import { save } from './components/save';
// import { makeSelect } from './components/select';


registerBlockType('create-block/glanum-leaflet', {
  title: 'Glanum leaflet',
  description: __('The Shortcode generator for Glanum Leaflet'),
  category: 'glanum-blocks',
  icon: {
    src: 'location-alt',
    background: '#af2e29',
    foreground: '#fff'
  },
  keywords: [__('map'), 'Glanum'],
  className: 'glanum-leaflet__block',
  supports: {
    multiple: false
  },
  example: {},
  attributes: {
    shortcode: {
      type: 'string',
    },
    shortcodeTitle: {
      type: 'string',
      default: __('Votre carte sera affichée ici')
    },
    title: {
      type: 'string',
      default: __('Mon titre')
    },
    geolocation: {
      type: 'boolean',
      default: false
    },
    filters: {
      type: 'boolean',
      default: true
    },
    types: {
      type: 'array',
      default: 'all'
    },
    display: {
      type: 'string',
      default: 'full'
    },
    search: {
      type: 'string',
      default: 'custom'
    },
    searchLanguage: {
      type: 'string',
      default: 'fr'
    },
    searchCountry: {
      type: 'string',
      default: 'fr'
    }
  },

  edit: (props) => {
    return edit(props);
  },

  save: (props) => {
    return save(props);
  }
});
